//import I18n from "i18n-js/index.js.erb"

var RoomTypeBuilderErrors = {

  general: function (errors) {
    var err = [];

    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    if (errors.code && errors.code.length) {
      for (var i = 0, ilen = errors.code.length; i < ilen; i++) {
        err.push(I18n.t('code') + ' ' + errors.code[i]);
      }
    }

    if (errors.maximum_occupancy && errors.maximum_occupancy.length) {
      for (var i = 0, ilen = errors.maximum_occupancy.length; i < ilen; i++) {
        err.push(I18n.t('maximum_occupancy') + ' ' + errors.maximum_occupancy[i]);
      }
    }

    if (errors.name && errors.name.length) {
      for (var i = 0, ilen = errors.name.length; i < ilen; i++) {
        err.push(I18n.t('name') + ' ' + errors.name[i]);
      }
    }

    if (errors.description && errors.description.length) {
      for (var i = 0, ilen = errors.description.length; i < ilen; i++) {
        err.push(I18n.t('description') + ' ' + errors.description[i]);
      }
    }

    if (errors.room_size && errors.room_size.length) {
      for (var i = 0, ilen = errors.room_size.length; i < ilen; i++) {
        err.push(I18n.t('room_size') + ' ' + errors.room_size[i]);
      }
    }

    // if (errors.bed_type && errors.bed_type.length) {
    //   for (var i = 0, ilen = errors.bed_type.length; i < ilen; i++) {
    //     err.push(I18n.t('bed_type') + ' ' + errors.bed_type[i]);
    //   }
    // }

    if (errors.status && errors.status.length) {
      for (var i = 0, ilen = errors.status.length; i < ilen; i++) {
        err.push(I18n.t('status') + ' ' + errors.status[i]);
      }
    }

    if (errors.color && errors.color.length) {
      for (var i = 0, ilen = errors.color.length; i < ilen; i++) {
        err.push(I18n.t('color') + ' ' + errors.color[i]);
      }
    }

    if (errors.amenities && errors.amenities.length) {
      for (var i = 0, ilen = errors.amenities.length; i < ilen; i++) {
        err.push(I18n.t('amenity') + ' ' + errors.amenities[i]);
      }
    }

    // if (errors.property_type && errors.property_type.length) {
    //   for (var i = 0, ilen = errors.property_type.length; i < ilen; i++) {
    //     err.push(I18n.t('property_type') + ' ' + errors.property_type[i]);
    //   }
    // }

    return err;
  },

  channels: function(errors) {
    var err = [];

    if (errors.property_type && errors.property_type.length) {
      for (var i = 0, ilen = errors.property_type.length; i < ilen; i++) {
        err.push(I18n.t('property_type') + ' ' + errors.property_type[i]);
      }
    }
    if (errors.ota_property_type && errors.ota_property_type.length) {
      for (var i = 0, ilen = errors.ota_property_type.length; i < ilen; i++) {
        err.push(I18n.t('ota_property_type') + ' ' + errors.ota_property_type[i]);
      }
    }

    if (errors.bathroom_count && errors.bathroom_count.length) {
      for (var i = 0, ilen = errors.bathroom_count.length; i < ilen; i++) {
        err.push(I18n.t('bathrooms_count') + ' ' + errors.bathroom_count[i]);
      }
    }

    if (errors.bed_type && errors.bed_type.length) {
      for (var i = 0, ilen = errors.bed_type.length; i < ilen; i++) {
        err.push(I18n.t('bed_type') + ' ' + errors.bed_type[i]);
      }
    }

    if (errors.channel_rate && errors.channel_rate.length) {
      for (var i = 0, ilen = errors.channel_rate.length; i < ilen; i++) {
        err.push(I18n.t('channel_rate') + ' ' + errors.channel_rate[i]);
      }
    }

    return err;
  },

  incidental_deposit: function (errors) {
    var err = [];

    if (errors.incidental_deposit && errors.incidental_deposit.length) {
      for (var i = 0, ilen = errors.incidental_deposit.length; i < ilen; i++) {
        err.push(I18n.t('incidental_deposit') + ' ' + errors.incidental_deposit[i]);
      }
    }

    return err;
  },

  price: function (errors) {
    var err = [];
    // console.log("price", errors)
    // if (errors.room_type_price && errors.room_type_price.length) {
    //   for (var i = 0, ilen = errors.room_type_price.length; i < ilen; i++) {
    //     err.push(I18n.t('pricing') + ' ' + errors.room_type_price[i] + '.');
    //   }
    // }

    //*** Price ***/
    if (errors.sunday_amount && errors.sunday_amount.length) {
      for (var i = 0, ilen = errors.sunday_amount.length; i < ilen; i++) {
        err.push(I18n.t('sunday_amount') + ' ' + errors.sunday_amount[i] + '.');
      }
    }
    if (errors.monday_amount && errors.monday_amount.length) {
      for (var i = 0, ilen = errors.monday_amount.length; i < ilen; i++) {
        err.push(I18n.t('monday_amount') + ' ' + errors.monday_amount[i] + '.');
      }
    }
    if (errors.tuesday_amount && errors.tuesday_amount.length) {
      for (var i = 0, ilen = errors.tuesday_amount.length; i < ilen; i++) {
        err.push(I18n.t('tuesday_amount') + ' ' + errors.tuesday_amount[i] + '.');
      }
    }
    if (errors.wednesday_amount && errors.wednesday_amount.length) {
      for (var i = 0, ilen = errors.wednesday_amount.length; i < ilen; i++) {
        err.push(I18n.t('wednesday_amount') + ' ' + errors.wednesday_amount[i] + '.');
      }
    }
    if (errors.thursday_amount && errors.thursday_amount.length) {
      for (var i = 0, ilen = errors.thursday_amount.length; i < ilen; i++) {
        err.push(I18n.t('thursday_amount') + ' ' + errors.thursday_amount[i] + '.');
      }
    }
    if (errors.friday_amount && errors.friday_amount.length) {
      for (var i = 0, ilen = errors.friday_amount.length; i < ilen; i++) {
        err.push(I18n.t('friday_amount') + ' ' + errors.friday_amount[i] + '.');
      }
    }
    if (errors.saturday_amount && errors.saturday_amount.length) {
      for (var i = 0, ilen = errors.saturday_amount.length; i < ilen; i++) {
        err.push(I18n.t('saturday_amount') + ' ' + errors.saturday_amount[i] + '.');
      }
    }
  // *** Minimum Stay ***
    if (errors.sunday_minimum_stay && errors.sunday_minimum_stay.length) {
      for (var i = 0, ilen = errors.sunday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('sunday_minimum_stay') + ' ' + errors.sunday_minimum_stay[i] + '.');
      }
    }
    if (errors.monday_minimum_stay && errors.monday_minimum_stay.length) {
      for (var i = 0, ilen = errors.monday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('monday_minimum_stay') + ' ' + errors.monday_minimum_stay[i] + '.');
      }
    }
    if (errors.tuesday_minimum_stay && errors.tuesday_minimum_stay.length) {
      for (var i = 0, ilen = errors.tuesday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('tuesday_minimum_stay') + ' ' + errors.tuesday_minimum_stay[i] + '.');
      }
    }
    if (errors.wednesday_minimum_stay && errors.wednesday_minimum_stay.length) {
      for (var i = 0, ilen = errors.wednesday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('wednesday_minimum_stay') + ' ' + errors.wednesday_minimum_stay[i] + '.');
      }
    }
    if (errors.thursday_minimum_stay && errors.thursday_minimum_stay.length) {
      for (var i = 0, ilen = errors.thursday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('thursday_minimum_stay') + ' ' + errors.thursday_minimum_stay[i] + '.');
      }
    }
    if (errors.friday_minimum_stay && errors.friday_minimum_stay.length) {
      for (var i = 0, ilen = errors.friday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('friday_minimum_stay') + ' ' + errors.friday_minimum_stay[i] + '.');
      }
    }
    if (errors.saturday_minimum_stay && errors.saturday_minimum_stay.length) {
      for (var i = 0, ilen = errors.saturday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('saturday_minimum_stay') + ' ' + errors.saturday_minimum_stay[i] + '.');
      }
    }

    return err;
  },

  rooms: function (errors) {
    var err = [];

    if (errors.enabled_room_type && errors.enabled_room_type.length) {
      for (var i = 0, ilen = errors.enabled_room_type.length; i < ilen; i++) {
        err.push(errors.enabled_room_type[i]);
      }
    }

    if (errors.rooms && errors.rooms.length) {
      for (var i = 0, ilen = errors.rooms.length; i < ilen; i++) {
        err.push(errors.rooms[i]);
      }
    }
    return err;
  },

  room_groups: function (errors) {
    var err = [];

    if (errors.enabled_room_type && errors.enabled_room_type.length) {
      for (var i = 0, ilen = errors.enabled_room_type.length; i < ilen; i++) {
        err.push(errors.enabled_room_type[i]);
      }
    }

    if (errors.room_groups && errors.room_groups.length) {
      for (var i = 0, ilen = errors.room_groups.length; i < ilen; i++) {
        err.push(errors.room_groups[i]);
      }
    }
    return err;
  },

  housekeeping_types: function (errors) {
    var err = [];

    if (errors.housekeeping_types && errors.housekeeping_types.length) {
      for (var i = 0, ilen = errors.housekeeping_types.length; i < ilen; i++) {
        err.push(errors.housekeeping_types[i]);
      }
    }
    return err;
  },

  bedrooms: function (errors) {
    var err = [];

    if (errors.bedrooms && errors.bedrooms.length) {
      for (var i = 0, ilen = errors.bedrooms.length; i < ilen; i++) {
        err.push(errors.bedrooms[i]);
      }
    }
    return err;
  },

};

export default RoomTypeBuilderErrors
